import { IDL as idl } from "@dfinity/agent";

export const NFTFactory: idl.InterfaceFactory = ({ IDL }: { IDL: any }) => {
  const Index = IDL.Nat;
  const TokenURIEntry = IDL.Record({
    tokenURI: IDL.Text,
    hash: IDL.Text,
    timestamp: IDL.Int,
  });
  const EventKind = IDL.Variant({
    transferKind: IDL.Record({
      tokenId: IDL.Text,
      memo: IDL.Text,
      recipient: IDL.Principal,
      sender: IDL.Principal,
    }),
    approveKind: IDL.Record({
      tokenId: IDL.Text,
      owner: IDL.Principal,
      spender: IDL.Principal,
    }),
    updateMinterKind: IDL.Record({
      minter: IDL.Principal,
      caller: IDL.Principal,
    }),
    initializationKind: IDL.Record({
      admin: IDL.Principal,
      name: IDL.Text,
      minter: IDL.Principal,
      caller: IDL.Principal,
      symbol: IDL.Text,
    }),
    mintKind: IDL.Record({
      minter: IDL.Principal,
      recipient: IDL.Principal,
      tokenURIEntry: TokenURIEntry,
    }),
    creationKind: IDL.Record({ deployer: IDL.Principal }),
    transferFromKind: IDL.Record({
      tokenId: IDL.Text,
      owner: IDL.Principal,
      memo: IDL.Text,
      recipient: IDL.Principal,
      spender: IDL.Principal,
    }),
    removeApprovalKind: IDL.Record({
      tokenId: IDL.Text,
      owner: IDL.Principal,
      spender: IDL.Principal,
    }),
    updateAdminKind: IDL.Record({
      admin: IDL.Principal,
      caller: IDL.Principal,
    }),
    updateKind: IDL.Record({
      minter: IDL.Principal,
      tokenURIEntry: TokenURIEntry,
    }),
  });
  const Event = IDL.Record({
    time: IDL.Int,
    index: Index,
    eventKind: EventKind,
  });
  const NonFungibleToken = IDL.Service({
    admin: IDL.Func([], [IDL.Principal], ["query"]),
    allTokensIDsWithOwners: IDL.Func(
      [],
      [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Principal))],
      ["query"]
    ),
    approve: IDL.Func([IDL.Principal, IDL.Text], [Index], []),
    canisterBalance: IDL.Func([], [IDL.Nat], ["query"]),
    eventsByTokenId: IDL.Func([IDL.Text], [IDL.Vec(Event)], ["query"]),
    getApproval: IDL.Func(
      [IDL.Principal, IDL.Principal, IDL.Text],
      [IDL.Text],
      ["query"]
    ),
    getApprovals: IDL.Func(
      [IDL.Principal, IDL.Principal],
      [IDL.Vec(IDL.Text)],
      ["query"]
    ),
    getEventRangeIndex: IDL.Func(
      [Index, Index],
      [IDL.Vec(IDL.Opt(Event))],
      ["query"]
    ),
    getIndex: IDL.Func([], [Index], ["query"]),
    initialize: IDL.Func(
      [IDL.Principal, IDL.Principal, IDL.Text, IDL.Text],
      [],
      []
    ),
    isInitialized: IDL.Func([], [IDL.Bool], ["query"]),
    isNFTv1: IDL.Func([], [IDL.Bool], ["query"]),
    mint: IDL.Func([IDL.Principal, IDL.Text, IDL.Text, IDL.Text], [Index], []),
    minter: IDL.Func([], [IDL.Principal], ["query"]),
    name: IDL.Func([], [IDL.Text], ["query"]),
    ownerOf: IDL.Func([IDL.Text], [IDL.Principal], ["query"]),
    removeApproval: IDL.Func([IDL.Principal, IDL.Text], [Index], []),
    symbol: IDL.Func([], [IDL.Text], ["query"]),
    tokensIdsOfOwner: IDL.Func([IDL.Principal], [IDL.Vec(IDL.Text)], ["query"]),
    topUp: IDL.Func([], [IDL.Nat], []),
    transfer: IDL.Func([IDL.Principal, IDL.Text, IDL.Text], [Index], []),
    transferFrom: IDL.Func(
      [IDL.Principal, IDL.Principal, IDL.Text, IDL.Text],
      [Index],
      []
    ),
    updateAdmin: IDL.Func([IDL.Principal], [], []),
    updateMinter: IDL.Func([IDL.Principal], [], []),
    updateToken: IDL.Func([IDL.Text, IDL.Text, IDL.Text], [Index], []),
    whoami: IDL.Func([], [IDL.Principal], []),
  });
  return NonFungibleToken;
};

export type NFTFactoryType = ReturnType<typeof NFTFactory>;

export default NFTFactory;
